import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UomDto, ItemTypeDto, MeasureDto,DamageStatusDto, DamageListDto} from '@cradua/data';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';


@Component({
  selector: 'cradua-damage-list-container',
  templateUrl: './damage-list-container.component.html',
  styleUrls: ['./damage-list-container.component.scss']
})
export class DamageListContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  damagestatuss$: Observable<DamageStatusDto[]>;
  uoms$: Observable<UomDto[]>;
  measures$: Observable<MeasureDto[]>;
  itemtypes$: Observable<ItemTypeDto[]>
  damagelists$: Observable<DamageListDto[]>;
  loading: boolean;
  isLoadingDamageStatus$: Observable<boolean>;
  isLoadingUom$: Observable<boolean>;
  isLoadingMeasure$: Observable<boolean>;
  isLoadingItemType$: Observable<boolean>;
  isLoadingDamageList$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoadingDamageStatus$ = this.gatwayFacade.isLoadingGateway("DamageStatus"); 
    this.isLoadingUom$ = this.gatwayFacade.isLoadingGateway("Uom"); 
    this.isLoadingMeasure$ = this.gatwayFacade.isLoadingGateway("Measure"); 
    this.isLoadingItemType$ = this.gatwayFacade.isLoadingGateway("ItemType");
    this.isLoadingDamageList$ = this.gatwayFacade.isLoadingGateway("DamageList");

    this.damagestatuss$ = this.gatwayFacade.loadGateway("DamageStatus");
    this.uoms$ = this.gatwayFacade.loadGateway("Uom");
    this.measures$ = this.gatwayFacade.loadGateway("Measure");  
    this.itemtypes$ = this.gatwayFacade.loadGateway("ItemType");
    this.damagelists$ = this.gatwayFacade.loadGateway("DamageList");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteDamageList(deletedValue: any) {
    this.gatwayFacade.remove("DamageList", deletedValue);
  }

// this method control both the create and update
  onSubmitDamageList(formValue: any) {
    const pullData = formValue.DamageLists;

// declare two empty array to hold update and create data
  const allUpdates = [] ;
  const addAllDamageList = [];

// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id) {
      allUpdates.push(pullData[i]);
    } else {
      addAllDamageList.push(pullData[i]);
    }
  }

// check if the addAllCountry array is not empty, then dispatch the data to the store
   if(addAllDamageList.length > 0) {
    this.gatwayFacade.add('DamageList', addAllDamageList);
   }

// dispatch update data to the store
   if(allUpdates.length > 0) {
    this.gatwayFacade.update('DamageList', allUpdates, ['id']);
   }
  }


}
